'use client';
import { useEffect, useState } from 'react';
import { showLoading, showSuccess, showError } from '@/lib/toast';
import { useGatewayEvents } from '@/lib/useGatewayEvents';

interface WorkerInfo { name: string; running: boolean; pid: number | null }

export default function WorkersPage() {
  const [workers, setWorkers] = useState<WorkerInfo[]>([]);

  async function load() {
    const res = await fetch('/api/workers');
    const data = await res.json();
    setWorkers(data.workers || []);
  }

  useEffect(() => {
    load();
  }, []);

  useGatewayEvents(['worker.status', 'runtime.status'], () => {
    void load();
  });

  async function toggle(name: string, action: 'start' | 'stop') {
    const toastId = showLoading(
      action === 'start' ? `Đang khởi động ${name}...` : `Đang dừng ${name}...`
    );
    
    try {
      const res = await fetch('/api/workers', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action, name }),
      });
      
      if (!res.ok) {
        throw new Error('Không thể thực hiện thao tác');
      }
      
      await load();
      
      showSuccess(
        action === 'start' 
          ? `Đã khởi động ${name} thành công!` 
          : `Đã dừng ${name} thành công!`,
        toastId
      );
    } catch (error) {
      showError(
        action === 'start'
          ? `Lỗi khi khởi động ${name}`
          : `Lỗi khi dừng ${name}`,
        toastId
      );
      console.error('Toggle worker error:', error);
    }
  }

  return (
    <div style={{ padding: 20 }}>
      <h1>Workers</h1>
      {workers.map((w) => (
        <div key={w.name} style={{ marginBottom: 8 }}>
          {w.name} - {w.running ? 'running' : 'stopped'}
          <button
            onClick={() => toggle(w.name, w.running ? 'stop' : 'start')}
            style={{ marginLeft: 8 }}
          >
            {w.running ? 'Stop' : 'Start'}
          </button>
        </div>
      ))}
    </div>
  );
}
